import { Component, ChangeDetectionStrategy, computed, inject, signal } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs/operators';
import { TranslateModule } from '@ngx-translate/core';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { IconComponent } from './shared/components/icon/icon.component';
import { WalletService } from './core/services/wallet';
import { CUSTOS_ENVIRONMENT, CustosEnvironment } from './core/models/environment';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SidebarComponent, TranslateModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './app.html',
  styleUrl: './app.scss',
  host: {
    '[class.sidebar-is-open]': 'sidebarOpen()',
  },
})
export class App {
  private readonly router = inject(Router);
  protected readonly walletService = inject(WalletService);
  private readonly env = inject<CustosEnvironment>(CUSTOS_ENVIRONMENT);

  protected readonly sidebarOpen = signal(false);
  protected readonly currentRoute = toSignal(
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
      map(() => this.router.url),
    ),
    { initialValue: this.router.url },
  );

  protected readonly expectedChainName = computed(() => {
    switch (this.env.chainId) {
      case 56: return 'BNB Chain';
      case 97: return 'BSC Testnet';
      case 11155111: return 'Sepolia';
      default: return `Chain ${this.env.chainId}`;
    }
  });

  onNavigate(route: string): void {
    this.router.navigate([route]);
    this.sidebarOpen.set(false);
  }

  async switchNetwork(): Promise<void> {
    try {
      await this.walletService.switchChain();
    } catch (err) {
      console.error('[Custos] Failed to switch network:', err);
    }
  }
}
